// TODO: Import React module
import { memo } from 'react';

// TODO: Import MUI module
import { Grid, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { Article, } from '@mui/icons-material';

// TODO: Import context

// TODO: Import custom component
import BoxImage from '../Common/BoxImage';
import StackImage from '../Common/StackImage';

const BoxHighlightedProgrammes = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component BoxHighlightedProgrammes Rendered');

    // TODO: Define useContext

    // TODO: Define variable
    const items = [
        {
            Title: '香港非遺月2026',
            Thumb: 'https://www.icho.hk/image/2026_ichm/testing/20260408_ICHM2026_c.jpg',
            URL: 'https://www.icho.hk/tc/web/icho/hk_ich_month_2026.html',
        },
        {
            Title: '粵港人民抗戰勝利八十周年展',
            Thumb: 'https://image.bastillepost.com/1200x/wp-content/uploads/hongkong/2025/08/20250828_CR_source_web_hk1-e1756377832931.jpg.webp',
            URL: 'https://hk.waranddefence.museum/tc/web/mcd/standingtogetherforpeacebuilding.html',
        },
        {
            Title: '航向太空⸺中國載人航天之旅',
            Thumb: 'https://hk.space.museum/image/Exhibition/CMSP/SExh_main%20page_1920x800.jpg',
            URL: 'https://hk.space.museum/tc/web/spm/exhibitions/special-exhibitions/cmse.html',
        },
        {
            Title: '適合親子同遊的博物館推介',
            Thumb: 'https://hk.space.museum/image/journal/article-32392897.jpeg',
            URL: 'https://www.discoverhongkong.com/tc/explore/attractions/guide-to-hong-kong-s-most-family-friendly-museums.html',
        },
        {
            Title: '沙頭角禁區探索一日遊',
            Thumb: 'https://dw-media.dotdotnews.com/dams/product/image/202312/18/657fbd86e4b0d9b5564551831.jpg',
            URL: 'https://www.discoverhongkong.com/tc/explore/discover-sha-tau-kok.html',
        },
    ];

    // TODO: Define event
    const handleClicked = (url) => { window.open(url, '_blank') };

    // TODO: Return component
    const RenderStackImage = ({ item }) => (
        <StackImage onClick={() => { handleClicked(item.URL) }} hover={true}>
            <BoxImage src={item.Thumb} />
            <Typography sx={{ alignItems: 'start', color: 'white', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                <Article sx={{ color: 'white' }} />
                {item.Title}
            </Typography>
        </StackImage>
    );

    return (
        <Grid container spacing={2} sx={{ mb: 2 }}>
            {
                items.map((item, i) => (
                    <Grid key={i} size={{ xs: 6, md: 4 }}>
                        <RenderStackImage item={item} />
                    </Grid>
                ))
            }
        </Grid>
    );
};

export default memo(BoxHighlightedProgrammes);